import isMobile from '../../plugins/is-mobile.js';

var vh = $(window).height();
// $('.l-header-fullScreenMenu').css('height', vh + 'px');

if (isMobile) {
  var contentsVh = vh - 60;
} else {
  var contentsVh = vh - 80;
}
$('.top-hero__bg').css('height', contentsVh + 'px');